import React from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { NoRecommendationWarning } from './no-recommendation-warning';

export const NoData = ({ data }) => {
  if (_.isArray(data) && _.isEmpty(data)) {
    return <NoRecommendationWarning />;
  }

  return null;
};

NoData.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({})),
};

NoData.defaultProps = {
  data: null,
};
